<template>
  <div class="container-fluid">
    <div class="row d-flex justify-content-center">
      <div class="col-lg-10">
        <h1 class="heading-color text-center p-5">{{productName}} Images</h1>
      </div>
    </div>
    <div class="row d-flex justify-content-center" v-if="this.$store.getters.apiStatus !== 'loading'">
      <div class="col-lg-10">
        <div class="overlay">
          <div class="main-loader">
            <MainLoader></MainLoader>
          </div>
        </div>
        <div class="row" v-if="this.images.length">
          <ItemCard v-for="image in images" :key="image.id" :item="image" :nextLink="'/download/image/' + image.id"></ItemCard>
        </div>
        <div class="not-found-div" v-else>
          <div class="row">
            <div class="col-md-12">
              <p class="text-center">No images found in {{productName}}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="main-loader" v-else>
      <MainLoader></MainLoader>
    </div>
  </div>
</template>

<script>
import Image from '@/models/Image'
import ItemCard from '@/components/ItemCard'
export default {
  name: 'Images',
  components: {
    ItemCard
  },
  data () {
    return {
      images: [],
      productName: ''
    }
  },
  mounted () {
    this.fetchImages()
  },
  methods: {
    fetchImages () {
      this.images = []
      $('.overlay').removeClass('d-none')
      this.$store.dispatch('fetchImages', this.$route.params.product_id)
        .then((result) => {
          result.data.images.forEach(category => {
            this.images.push(new Image(category))
          })
          $('.overlay').addClass('d-none')
          this.productName = result.data.product_name
          document.title = 'Img-Lib - ' + this.productName + ' images'

          if (this.productName.includes('Spec Sheet') && this.images.length) {
            this.$router.push('/download/image/' + this.images[0].id)
          }
        })
        .catch((err) => this.$helper.catchHandler(err))
    }
  }
}

</script>

<style scoped>
.not-found-div {
  height: calc(70vh - 190px);
}
@media screen and (max-width: 500px){
  .not-found-div {
    height: calc(70vh - 100px);
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Images.vue